import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';

const ProductChart = ({ products = [] }) => {
  const [options, setOptions] = useState({});

  useEffect(() => {
    // Si recibimos órdenes en vez de productos procesados, extraemos los productos
    let productData = products;
    
    if (productData.length === 0 && Array.isArray(products)) {
      // Procesamos las órdenes para obtener los productos más vendidos
      const productCounts = {};
      
      products.forEach(order => {
        if (order.OrderItems) {
          order.OrderItems.forEach(item => {
            if (productCounts[item.name]) {
              productCounts[item.name] += parseInt(item.quantity);
            } else {
              productCounts[item.name] = parseInt(item.quantity);
            }
          });
        }
      });
      
      productData = Object.entries(productCounts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([name, count]) => ({ name, count }));
    }

    // Ordenar productos de mayor a menor cantidad vendida
    productData = productData.sort((a, b) => b.count - a.count);

    const productNames = productData.map(product => {
      // Acortar nombres muy largos
      const name = product.name;
      return name.length > 25 ? name.substring(0, 22) + '...' : name;
    });
    const productCounts = productData.map(product => product.count);

    const colorPalette = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452'];

    setOptions({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '8%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        data: productNames,
        axisLabel: {
          interval: 0,
          rotate: 0
        }
      },
      series: [
        {
          name: 'Cantidad vendida',
          type: 'bar',
          data: productCounts,
          itemStyle: {
            color: function(params) {
              return colorPalette[params.dataIndex % colorPalette.length];
            },
            borderRadius: [0, 4, 4, 0]
          },
          label: {
            show: true,
            position: 'right'
          }
        }
      ]
    });
  }, [products]);

  return <ReactECharts option={options} style={{ height: '100%' }} />;
};

export default ProductChart;
